import React from "react";
import { FileText, Gift, Check } from "lucide-react";
import { resolveImage, formatPrice } from "@/lib/api";

const Thumb = ({ p }) => (
  <div className="w-10 h-12 rounded-md bg-slate-100 overflow-hidden flex-shrink-0 flex items-center justify-center">
    {p.cover_url ? <img src={resolveImage(p.cover_url)} alt="" className="w-full h-full object-cover" /> : <FileText className="w-5 h-5 text-slate-400" />}
  </div>
);

const Row = ({ p, active, onClick, right, testid }) => (
  <button
    type="button"
    data-testid={testid}
    onClick={onClick}
    className={`w-full flex items-center gap-3 rounded-xl border-2 p-2 text-left transition-colors ${active ? "border-brand-blue bg-blue-50" : "border-border bg-white hover:border-brand-blue/40"}`}
  >
    <Thumb p={p} />
    <div className="flex-1 min-w-0">
      <div className="text-sm font-bold truncate">{p.title}</div>
      {p.description && <div className="text-[11px] text-slate-500 truncate">{p.description}</div>}
    </div>
    <span className="text-xs font-bold text-brand-blue whitespace-nowrap">{right}</span>
    <span className={`w-5 h-5 rounded-full border-2 flex items-center justify-center ${active ? "bg-brand-blue border-brand-blue text-white" : "border-slate-300"}`}>
      {active && <Check className="w-3 h-3" strokeWidth={3} />}
    </span>
  </button>
);

export const PdfPicker = ({ options, giftId, setGiftId, paidIds, setPaidIds }) => {
  const { gifts = [], paid = [] } = options || {};
  if (!gifts.length && !paid.length) return null;
  const paidAvailable = paid.filter((p) => p.id !== giftId);
  const togglePaid = (id) => setPaidIds(paidIds.includes(id) ? paidIds.filter((x) => x !== id) : [...paidIds, id]);
  const pickGift = (id) => {
    setGiftId(giftId === id ? null : id);
    setPaidIds(paidIds.filter((x) => x !== id));
  };

  return (
    <section className="bg-white border border-border rounded-2xl p-4" data-testid="pdf-picker">
      <h2 className="font-heading font-bold text-brand-blue flex items-center gap-2"><Gift className="w-5 h-5" /> PDF digitali</h2>
      <p className="text-xs text-slate-500 mt-1">Si scaricano subito dopo il pagamento. Non pesano sulla spedizione.</p>
      {gifts.length > 0 && (
        <div className="mt-3">
          <div className="text-xs font-bold uppercase tracking-wider text-emerald-700 mb-2">Scegli 1 PDF in omaggio</div>
          <div className="space-y-2">
            {gifts.map((p) => (
              <Row key={p.id} p={p} testid={`gift-pdf-${p.id}`} active={giftId === p.id} onClick={() => pickGift(p.id)} right="GRATIS" />
            ))}
          </div>
        </div>
      )}
      {paidAvailable.length > 0 && (
        <div className="mt-4">
          <div className="text-xs font-bold uppercase tracking-wider text-brand-blue mb-2">Aggiungi altri PDF</div>
          <div className="space-y-2">
            {paidAvailable.map((p) => (
              <Row key={p.id} p={p} testid={`paid-pdf-${p.id}`} active={paidIds.includes(p.id)} onClick={() => togglePaid(p.id)} right={formatPrice(p.price)} />
            ))}
          </div>
        </div>
      )}
    </section>
  );
};
